module.exports = __webpack_public_path__ + "img/simple.2ad490e5.png";